import React from "react";

import Menara from '../img/menara_desktop.png';
import Ornament from '../img/oval_desktop.png';
import Background from '../img/background_desktop.png';


class Top extends React.Component {
  render() {
    return (
      <div class="d-flex h-100">
        <div class="align-self-center w-100 row text-center">
          <div class = 'moving-bg align-self-center d-none d-sm-none d-md-block'>
            <div style={{position: 'relative', left: '-30%',}}>
              <img class = 'align-self-center' src={Background} alt = "Desktop Background" style ={{zIndex: -10, width: '100%', opacity:0.5}}/>
            </div>
          </div>
          <div class ="col-md-5">

          </div>
          <div class ="col-md-7">
            <div class = 'moving-ornament'>
              <div class = 'moving-bg align-self-center d-md-none d-lg-none'>
                <div style={{position: 'relative', left: '-50%', top:'83px'}}>
                  <img class = 'align-self-center' src={Background} alt = "Desktop Background" style ={{zIndex: -10, width: '100%', opacity:0.5}}/>
                </div>
              </div>
              <img src={Ornament} alt = "Oval Ornament 2" style ={{ width: '110%', position: 'absolute', left:'-100%', top: '16%' }}/>
              <img src={Menara} alt = "Menara Kompas" style = {{ width:'100%' }}/>
              <img src={Ornament} alt = "Oval Ornament 1" style ={{width: '40%', position: 'absolute', bottom: '20%'}}/>
            </div>
          </div>
          <div class ="col-md-5">
            <div class = "title-text">
              <h1 class = 'heading-title'>Enlighten Through Technology</h1>
              <p class = 'paragraph'>
                Oval is a major part of <strong>Kompas Gramedia’s</strong> digital transformation. We execute big ideas to help Kompas Gramedia to thrive in the digital era, continuing our common goal in enlightening the people of Indonesia.
              </p>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Top;



// WEBPACK FOOTER //
// ./src/components/Top.js